<template>
  <div>
    <LeftListMember :pos="2"></LeftListMember>
    <div class="g-row2">
      <div class="m-hone1">
        <ul class="g-tablist1">
          <li class="li">
            <li class="li">
              <router-link to="/info-center" class="txt">我的信息</router-link>
            </li>
            <li class="li on">
              <router-link to="/center-password" class="txt">修改密码</router-link>
            </li>
            <li v-if="$store.state.user.userInfo.type==0" class="li">
              <router-link to="/center-qualifications" class="txt">资质认证</router-link>
            </li>
        </ul>
        <div class="contect">
          <div class="m-infobox3">
            <div class="g-titin1">修改密码</div>
            <div class="m-popin1">
              <form action="" onsubmit="return false">
              <div class="form">
                <div class="group">
                  <div class="infobox">
                    <el-input placeholder="原始密码" v-model="form.nowpass"  show-password></el-input>
                  </div>
                </div>
                <div class="group">
                  <div class="infobox">
                    <el-input placeholder="8-20位密码，字母/数字/符号至少2种" v-model="form.pass" show-password></el-input>
                  </div>
                </div>
                <div class="group-code">
                  <button class="btn" v-loading="saving" @click="save">
                    确认修改
                  </button>
                  <!-- <div class="info">注：确认后返回登录界面</div> -->
                </div>
              </div>
            </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftListMember from "@/components/LeftListMember.vue";
import {getApiRes} from "@/api/apiUtil";
import {repass} from "@/api/user";
export default {
  components: {
    LeftListMember,
  },
  data() {
    return {
      form: {
        nowpass: "",
        pass: "",
        repass: '',
      },
      saving: false,
    }
  },
  watch:{
    'form.pass'(v){
      this.form.repass = v
    }
  },
  computed: {},
  mounted() {},
  methods: {
    async save(){
      if(this.saving) return
      if(!this.form.nowpass){
        this.$message.error("原始密码不能为空")
        return
      }
      if(!this.form.pass){
        this.$message.error("新密码不能为空")
        return
      }
      if(this.form.pass.length < 6 || this.form.pass.length > 20) {
        this.$message.error("密码长度应为6-20位")
        return
      }

      this.saving = true
      await getApiRes(repass(this.form), 1, 1,1,1)
      this.saving = false
    }
  },
};
</script>

<style lang="scss" scoped></style>
